export const getUrlParams = (name, str) => {
  let pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
  str = str || window.location.search;
  let arr, match = "";
  while ((arr = pattern.exec(str)) !== null) {
    match = arr[1];
  }
  return match;
};

/**
 * 往剪切板添加内容
 * @param value
 * @returns {boolean}
 */
export const clipboard = (value) => {
  if (document.execCommand) {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', value);
    input.select();

    document.execCommand('copy');
    document.body.removeChild(input);

    return true;
  }

  return false;
};

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * @param {string} fmt
 * @param {object} time 需要处理的时间独享
 *
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export let Format = (time, fmt) => { //author: meizz
  fmt = fmt || "yyyy-MM-dd hh:mm:ss";
  if (typeof time !== 'object') time = new Date(time);
  let o = {
    "M+": time.getMonth() + 1, //月份
    "d+": time.getDate(), //日
    "h+": time.getHours(), //小时
    "m+": time.getMinutes(), //分
    "s+": time.getSeconds(), //秒
    "q+": Math.floor((time.getMonth() + 3) / 3), //季度
    "S": time.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};
/**
 * 导出文件工具方法
 * 需要将返回的文件流对象直接传入,
 * 如果没有数据， 返回一个对象
 */
export let exportFile = (blob, name = 'name') => {
  // if (blob.type.endsWith('/html')) return { msg: "暂无数据" };
  let end = blob.type.split('/')[1];
  end = end === 'pdf' ? end : 'csv';
  let downloadUrl = window.URL.createObjectURL(blob);
  let anchor = document.createElement("a");
  anchor.href = downloadUrl;
  anchor.download = `${name}${Format(new Date(), 'yyyyMMddhhmmss')}.${end}`;
  anchor.click();
  window.URL.revokeObjectURL(blob);

};

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export const deepCopy = (obj, cache = []) => {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  });

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
};
//判断数组
export const isArrayFn = (arr) => {
  return Object.prototype.toString.call(arr) === '[object Array]';
};

//将base64转换为文件
export const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
};

//从session中取json数据
export const getCacheList = (key,initVal) => {
  let list = initVal;
  if(sessionStorage.getItem(key)){
    try {
      list = JSON.parse(sessionStorage.getItem(key));
    }
    catch (e) {
      console.error('sessionStorage ' + key + ' 不是json');
    }
  }
  return list;
};
